import { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import { plateformSettingServices } from "../../../APIServices/PasswordManagement/plateformSettingServices";
import Swal from "sweetalert2";
import { BiReset } from "react-icons/bi";

const FunctionSettings = ({
  currentUserData,
  getSinglePlateformSettings,
  plateformSettings,
  auth
}) => {
  const [showFunctionSettings, setShowFunctionSettings] = useState("");
  const [functionSettings, setFunctionSettings] = useState("");
  const [loader, setLoader] = useState("");

  const addUpdatePlateformSettings = async (type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${type} Function setting?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(type);
        let userData = {};
        userData.functionSettings = type === "update" ? functionSettings : {};
        let data = await plateformSettingServices.addUpdatePlateformSettings(
          auth,
          userData
        );
        if (data?.statusCode === 200) {
          getSinglePlateformSettings();
        }
        setLoader("");
      }
    });
  };

  useEffect(() => {
    if (plateformSettings) {
      setFunctionSettings(
        plateformSettings?.settings?.functionSettings || ""
      );
      setShowFunctionSettings(
        plateformSettings?.settings?.showFunctionSettings || ""
      );
    }
  }, [plateformSettings]);

  const handleChange = (e) => {
    const { name, checked } = e.target;

    setFunctionSettings((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleFunctionSettingsChange = (value) => {
    setFunctionSettings(prev =>
      Object.fromEntries(
        Object.keys(prev).map(key => [key, value])
      )
    );
  };

  let allSelected = Object.values(functionSettings).every(value => value === true);
  let noUpdate = Object.values(plateformSettings?.settings?.functionSettings).every(value => value === false);

  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3 hstack justify-content-between">
        <h5 className="fw-bold mb-1">Function Settings</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <Form.Group className="mb-2" style={{ fontSize: 13 }}>
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  className="fw-bold"
                  checked={allSelected}
                  onChange={() => handleFunctionSettingsChange(!allSelected)}
                />
                <Form.Check
                  type="checkbox"
                  name="hideShowEdit"
                  label="Edit Option"
                  disabled={showFunctionSettings?.hideShowEdit}
                  checked={functionSettings?.hideShowEdit && !showFunctionSettings?.hideShowEdit}
                  onChange={handleChange}
                />
                {currentUserData?.loginAccountId &&
                  <Form.Check
                    type="checkbox"
                    name="hideShowShare"
                    label="Share Option"
                    disabled={showFunctionSettings?.hideShowShare}
                    checked={functionSettings?.hideShowShare && !showFunctionSettings?.hideShowShare}
                    onChange={handleChange}
                  />
                }
                <Form.Check
                  type="checkbox"
                  name="hideShowMove"
                  label="Move Option"
                  disabled={showFunctionSettings?.hideShowMove}
                  checked={functionSettings?.hideShowMove && !showFunctionSettings?.hideShowMove}
                  onChange={handleChange}
                />
                <Form.Check
                  type="checkbox"
                  name="hideShowDuplicate"
                  label="Duplicate Option"
                  disabled={showFunctionSettings?.hideShowDuplicate}
                  checked={functionSettings?.hideShowDuplicate && !showFunctionSettings?.hideShowDuplicate}
                  onChange={handleChange}
                />
                <Form.Check
                  type="checkbox"
                  name="hideShowArchive"
                  label="Archive Option"
                  disabled={showFunctionSettings?.hideShowArchive}
                  checked={functionSettings?.hideShowArchive && !showFunctionSettings?.hideShowArchive}
                  onChange={handleChange}
                />
                <Form.Check
                  type="checkbox"
                  name="hideShowDelete"
                  label="Delete Option"
                  disabled={showFunctionSettings?.hideShowDelete}
                  checked={functionSettings?.hideShowDelete && !showFunctionSettings?.hideShowDelete}
                  onChange={handleChange}
                />
                <Form.Check
                  type="checkbox"
                  name="hideShowPermanentDelete"
                  label="Permanent Delete Option"
                  disabled={showFunctionSettings?.hideShowPermanentDelete}
                  checked={functionSettings?.hideShowPermanentDelete && !showFunctionSettings?.hideShowPermanentDelete}
                  onChange={handleChange}
                />
                {currentUserData?.loginAccountId &&
                  <Form.Check
                    type="checkbox"
                    name="hideShowShareHistory"
                    label="Share History Option"
                    disabled={showFunctionSettings?.hideShowShareHistory}
                    checked={functionSettings?.hideShowShareHistory && !showFunctionSettings?.hideShowShareHistory}
                    onChange={handleChange}
                  />
                }
                <Form.Check
                  type="checkbox"
                  name="hideShowUpdatedActivity"
                  label="Updated Activity Option"
                  disabled={showFunctionSettings?.hideShowUpdatedActivity}
                  checked={functionSettings?.hideShowUpdatedActivity && !showFunctionSettings?.hideShowUpdatedActivity}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                If the checkbox is checked, the related options will be hidden; otherwise, when it is unchecked, the options will be visible on the platform.
              </Form.Label>
              <div className="hstack justify-content-end gap-2">
                {!noUpdate &&
                  <Button
                    disabled={loader}
                    onClick={() => addUpdatePlateformSettings("reset")}
                    variant="outline-danger"
                    style={{ fontSize: 13 }}
                    title="Reset"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <BiReset /> Reset
                  </Button>
                }
                <Button
                  disabled={loader}
                  onClick={() => addUpdatePlateformSettings("update")}
                  variant="outline-primary"
                  style={{ fontSize: 13 }}
                  title="Update"
                  className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                >
                  <FaRegEdit /> Update
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default FunctionSettings;
